"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadNews = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var message_1 = require("../../model/message");
var service_1 = require("../../../library/base/service");
var ReadNews = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ReadNews, _super);
    function ReadNews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '阅读消息接口';
        _this.code = '101006';
        _this.desc = '阅读消息接口';
        _this.requestParams = new message_1.ReadNewsRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ReadNews;
}(service_1.BaseService));
exports.ReadNews = ReadNews;
//# sourceMappingURL=readNews.js.map